
import Typography from "@mui/material/Typography";
import "./invalidRequest.scss";
import invalidImg from '../../assets/images/error.png';
import CloseIcon from '@mui/icons-material/Close';
import {Tooltip,IconButton} from '@mui/material';
import { callByItems } from "../../../constants";
import {encryptText} from "../../../common"

const InvalidRequest = ({code = 0 ,msg='',callBy,widget_id}) => {
    const handleCloseEchoIframe = () => {
        if(widget_id){ 
        var iframeCloseData = {
          msg : "closeIframe",
          appId : `cr_${widget_id}`
        };
        window.parent.postMessage(iframeCloseData, '*');
        var generateEncryptedID=encryptText(`cr_${widget_id}`)
        var opendIframe=localStorage.getItem("eoi")
        if(opendIframe){
          let newIframeIds = [];
           newIframeIds=JSON.parse(opendIframe)
          if(newIframeIds.includes(generateEncryptedID)){
            const updatedIframeIds = newIframeIds.filter(item => item !== generateEncryptedID);
            localStorage.setItem("eoi", JSON.stringify(updatedIframeIds));
           }
        }}else{
            window.parent.postMessage('closeApplicantIframe', '*');
        } 
       }
    return ( 
        <div className="ir-outer">
            {callBy != callByItems.livechat?
            <Tooltip title="Close">
            <IconButton type="button" onClick={handleCloseEchoIframe}>
              <CloseIcon />
            </IconButton>
            </Tooltip>:null}
            <div class="notfound">
                <div class="content">
                    <div class="notfound-error">
                        <h1>{code?code:400}</h1>
                    </div>
                    <h2>{msg?msg:'Bad Request'}</h2>
                    <p>{code == 201?'':'The request cannot be fulfilled due to bad syntax.'}</p>
                </div>
                <div class="errorimage">
                    <img src={invalidImg} alt="Invalid Request" />
                </div>
            </div>
        </div>
    )
}

export default InvalidRequest ;
